<template>
  <div>
    <div class="accumulation-ct">
      <form-section
        :title="$t('CampaignForm_Accumulation_Title')"
        :description="$t('CampaignForm_Accumulation_Desc')"
        :separator="true"
        :is-changed="model.diff && model.diff.includes('accumulation')"
      >
        <conditions-editor
          ref="accumulation-conditions-editor"
          v-model="model.accumulation_conditions"
          data-model-name="Campaign"
          data-model-attribute="accumulation_conditions"
          attribute-list-data-url="/push/accumulation-rule/attribute-list-data"
          :preview="false"
          :no-data-alert="false"
          :single-level="true"
        />
      </form-section>

      <form-section
        :title="$t('CampaignForm_Accumulation_QualificationTrigger_Title')"
        :description="$t('CampaignForm_Accumulation_QualificationTrigger_Desc')"
        :separator="true"
      >
        <qualification-trigger :model="model" />
      </form-section>
    </div>

    <div class="footer">
      <div class="footer-ct">
        <el-button type="primary" @click="nextStep" data-qa="next-step-btn">
          {{ $t('CampaignForm_Events_NextButton_Title') }}
          <i class="el-icon-arrow-right el-icon-right"></i>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { campaignTypeEnum } from '@/modules/campaigns/enum/CampaignTypeEnum'
import { EventBus } from '@/core/EventBus'
import FormSection from '@/common/components/form/FormSection.vue'
import ConditionsEditor from '@/common/components/ConditionsEditor.vue'
import QualificationTrigger from '../components/events/QualificationTrigger'

export default {
  name: 'StepAccumulation',

  components: {
    QualificationTrigger,
    ConditionsEditor,
    FormSection
  },

  props: {
    model: {
      type: Object
    }
  },

  data() {
    return {
      campaignTypeEnum
    }
  },

  methods: {
    nextStep() {
      EventBus.$emit('campaign-create-next-step')
    }
  }
}
</script>

<style scoped>
.accumulation-ct {
  padding-bottom: 60px;
}
.footer {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 60px;
  background: #ffffff;
  z-index: 1;
  border-top: 1px solid #e5e5e5;
}
.footer-ct {
  margin-right: 20px;
  margin-bottom: 12px;
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/pages/StepAccumulation.vue